import { createFileRoute } from "@tanstack/react-router";
import { UserProfile } from "@/modules/userProfile";
import CustomNotFound from "@/modules/notFound";

export const Route = createFileRoute("/user-profile")({
  component: UserProfile,
  notFoundComponent: CustomNotFound,
});
